import { Prompt } from "@/lib/types";

export const HOMEPAGE_SEED_PROMPTS: Prompt[] = [
  {
    id: "seed-1",
    userId: "u1",
    username: "Navakishor",
    avatarId: 1,
    title: "Resume Optimizer v3 (ATS-Bypass)",
    content: "Act as an expert technical recruiter and ATS specialist. Review the following resume and job description. Rewrite the bullet points to maximize keyword match, quantify impact, and strictly use the X-Y-Z formula (Accomplished [X] as measured by [Y], by doing [Z]).",
    category: "hr-recruitment",
    likes: 342,
    comments: 28,
    createdAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 3).toISOString(),
    copyCount: 1205,
    geoMetadata: {
      intent: "transform",
      use_case: "resume-cover-letter",
      models: { recommended: "GPT-4o", tested: ["Claude 3.5 Sonnet"] },
      reliability: { tested_by_author: true, community_verified: 89, reported_issues: 2 },
      version: 3,
    }
  },
  {
    id: "seed-2",
    userId: "u2",
    username: "Elena_AI",
    avatarId: 4,
    title: "SaaS Landing Page Copywriter",
    content: "Act as a direct-response copywriter. I am launching a B2B SaaS. Generate a high-converting landing page structure following the PASTOR framework (Problem, Amplification, Story, Transformation, Offer, Response). Focus on benefits over features.",
    category: "copywriting",
    likes: 184,
    comments: 12,
    createdAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 7).toISOString(),
    copyCount: 843,
    geoMetadata: {
      intent: "generate",
      use_case: "marketing",
      models: { recommended: "Claude 3.5 Sonnet", tested: ["GPT-4", "Gemini Pro"] },
      reliability: { tested_by_author: true, community_verified: 45, reported_issues: 0 },
      version: 1,
    }
  },
  {
    id: "seed-3",
    userId: "u3",
    username: "DevNinja",
    avatarId: 8,
    title: "React Component Refactor & Test Gen",
    content: "Review the provided React component. Refactor it to use functional components, hooks, and clean up any performance bottlenecks. Then, generate a comprehensive suite of Jest and React Testing Library unit tests covering all edge cases.",
    category: "coding-development",
    likes: 512,
    comments: 41,
    createdAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 14).toISOString(),
    copyCount: 2150,
    geoMetadata: {
      intent: "code",
      use_case: "debugging",
      models: { recommended: "Claude 3.5 Sonnet", tested: ["GPT-4o"] },
      reliability: { tested_by_author: true, community_verified: 156, reported_issues: 5 },
      version: 4,
    }
  }
];

export const HERO_SEED_PROMPT: Prompt = {
  id: "hero-1",
  userId: "u1",
  username: "Navakishor",
  avatarId: 1,
  title: "Advanced Data Analysis Pipeline",
  content: "Analyze the attached CSV dataset. Identify the top 3 anomalies, clean any missing values using median imputation, and generate a Python script using pandas and matplotlib to visualize the correlation matrix.",
  category: "data-science-engineering",
  likes: 892,
  comments: 64,
  createdAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 30).toISOString(),
  copyCount: 4320,
  geoMetadata: {
    intent: "analyze",
    use_case: "data-analysis",
    models: { recommended: "GPT-4o", tested: ["Claude 3.5 Sonnet", "Gemini 1.5 Pro"] },
    reliability: { tested_by_author: true, community_verified: 340, reported_issues: 12 },
    version: 5,
  }
};
